/*-----------------------------------------------------------------
- Blog Card
-----------------------------------------------------------------*/
export default {

    comments_count: '{0} دیدگاه',

};
